document.addEventListener('DOMContentLoaded', () => {

  const items = document.querySelectorAll('.gt-mega-menu__item');

  items.forEach((item) => {

    let timeout;

    item.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
      item.classList.add('is-open');
    });

    item.addEventListener('mouseleave', () => {
      timeout = setTimeout(() => {
        item.classList.remove('is-open');
      }, 120);
    });

  });

});